<template>
  <form class="mt-4" @submit.prevent="submitAgeForm" @keyup.enter="submitAgeForm">
    <Checkbox
      v-for="ageRange in ageRanges"
      :key="ageRange.id"
      v-model="selectedAgeRanges"
      :label-name="ageRange.optionText"
      :value="ageRange.id"
    />
    <div class="w-full mt-24">
      <Button value="Save" type="submit" size="medium" class="w-full" />
    </div>
  </form>
</template>

<script lang="ts">
import Checkbox from '../../checkbox/Checkbox.vue';
import Button from '../../button/Button.vue';

export default {
  name: 'AgePopup',
  components: { Checkbox, Button },
  props: {
    ageRanges: {
      type: Array<Object>,
      default: [],
    },
    filterAges: {
      type: Array<any>,
      default: [],
    },
    closeModal: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectedAgeRanges: this.filterAges,
    };
  },
  methods: {
    submitAgeForm() {
      this.closeModal();

      const { query } = this.$route;
      this.$router.push({ query: { ...query, ageRangeId: JSON.stringify(this.selectedAgeRanges) } });
    },
  },
};
</script>
